export class InvalidOperationError extends Error {}
